export default "__VITE_ASSET__CM$sxVfQ__"